import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import {
  hideModalDelete,
  onClickDeleteBank,
} from 'actions/setting/bankAccount';
import styles from './style.css';

class DeleteModal extends React.Component {
  render() {
    const { showModalDelete, bankAccountForm } = this.props;

    return (
      <Modal
        show={showModalDelete}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header className={`${styles['bg-danger']}`}>
          <Modal.Title>
            <span className="pull-left">Delete Bank Account</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Do you want to delete{' '}
          <strong>
            {bankAccountForm.bankName} - {bankAccountForm.accountNumber}
          </strong>
          ?
        </Modal.Body>

        <Modal.Footer>
          <button
            className={`btn mr-10px ${styles['btn-outline-dark']} ${
              styles['btn-large']
            }`}
            type="button"
            onClick={this._onClickCancel}
          >
            Cancel
          </button>
          <button
            className={`btn btn-danger ${styles['btn-large']}`}
            onClick={this._onClickDelete}
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickCancel = e => {
    this.props.dispatch(hideModalDelete());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickDelete = e => {
    const { bankAccountForm, profile } = this.props;
    this.props.dispatch(onClickDeleteBank(bankAccountForm, profile));
    e.preventDefault();
    e.stopPropagation();
  };
}

function mapStateToProps(state) {
  const { profile, showModalDelete } = state.setting.bankAccount;

  return {
    profile,
    showModalDelete,
    bankAccountForm: getFormValues('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteModal);
